// Bambody v3 cart drawer.
// Fetches /cart.js, renders line items, wires qty +/- and remove.
// Opens on the "bam:cart:added" event fired by bambody-v3-shop.js, and via
// window.bamV3CartOpen() (used by the v2 header cart pill).

(function () {
  const FREE_SHIPPING_CENTS = 6000

  const $ = (sel, root) => (root || document).querySelector(sel)

  function fmtPrice(cents) {
    const n = Number(cents) || 0
    return '$' + (n / 100).toFixed(2)
  }

  function stripFlow(raw) {
    return String(raw || '').replace(/^(Heavy|Light)(?:\s+Flow)?\s*—\s*/, '').trim()
  }

  // "Bambody Hipster" → "Hipster"
  function shortTitle(t) {
    return String(t || '').replace(/^Bambody\s+/i, '')
  }

  function drawer() { return document.getElementById('bam-v3-cart-drawer') }

  function updateHeaderCount(itemCount) {
    // v2 header renders "Cart · N" — update the span text so the count reflects
    // the fresh cart without a page reload.
    document.querySelectorAll('.bam-v2-nav__cart span').forEach((el) => {
      el.textContent = `Cart · ${itemCount}`
    })
  }

  function updateShipTrack(cart) {
    const track = $('#bam-cd-ship-track')
    if (!track) return
    if (!cart.items?.length) { track.setAttribute('hidden', ''); return }
    track.removeAttribute('hidden')
    const remaining = Math.max(0, FREE_SHIPPING_CENTS - cart.items_subtotal_price)
    const pct = Math.min(100, (cart.items_subtotal_price / FREE_SHIPPING_CENTS) * 100)
    const copy = $('#bam-cd-ship-copy')
    if (remaining > 0) {
      copy.innerHTML = `Add <strong>${fmtPrice(remaining)}</strong> to unlock free shipping.`
    } else {
      copy.innerHTML = 'Free shipping unlocked. 🎉'
    }
    $('#bam-cd-ship-fill').style.width = pct + '%'
  }

  function renderLineItem(item) {
    // Shopify /cart.js returns image, product_title, variant_title, options_with_values,
    // final_line_price (cents), quantity, key.
    const opts = item.options_with_values || []
    const chips = opts.map((o) => `<span class="bam-cd__chip">${stripFlow(o.value)}</span>`).join('')
    const img = item.image ? `<img src="${item.image}" alt="${item.product_title}">` : `<div class="bam-cd__ph"></div>`
    return `
      <div class="bam-cd__line" data-key="${item.key}">
        <a class="bam-cd__thumb" href="${item.url}">${img}</a>
        <div class="bam-cd__info">
          <a class="bam-cd__name" href="${item.url}">${shortTitle(item.product_title)}</a>
          <div class="bam-cd__chips">${chips}</div>
          <div class="bam-cd__ctrls">
            <div class="bam-cd__qty" role="group" aria-label="Quantity">
              <button type="button" class="bam-cd__qty-btn" onclick="bamV3CartChange('${item.key}', ${item.quantity - 1})" aria-label="Decrease">−</button>
              <span class="bam-cd__qty-val">${item.quantity}</span>
              <button type="button" class="bam-cd__qty-btn" onclick="bamV3CartChange('${item.key}', ${item.quantity + 1})" aria-label="Increase">+</button>
            </div>
            <button type="button" class="bam-cd__remove" onclick="bamV3CartChange('${item.key}', 0)">Remove</button>
          </div>
        </div>
        <div class="bam-cd__price">${fmtPrice(item.final_line_price)}</div>
      </div>
    `
  }

  function renderEmpty() {
    return `
      <div class="bam-cd__empty">
        <div class="bam-cd__empty-icon" aria-hidden="true">
          <svg width="44" height="44" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><circle cx="8" cy="21" r="1"/><circle cx="19" cy="21" r="1"/><path d="M2.05 2.05h2l2.66 12.42a2 2 0 002 1.58h9.78a2 2 0 001.95-1.57l1.65-7.43H5.12"/></svg>
        </div>
        <div class="bam-cd__empty-title">Your bag is empty.</div>
        <div class="bam-cd__empty-sub">Start with our bestselling Hipster, or shop the full range.</div>
        <button type="button" class="bam-cd__empty-cta" onclick="bamV3CartClose();bamV3SmoothTo && bamV3SmoothTo('bam-v3-shop-anchor')">Shop the range</button>
      </div>
    `
  }

  function render(cart) {
    updateHeaderCount(cart.item_count)
    const body = $('#bam-cd-body')
    const foot = $('#bam-cd-foot')
    const title = $('#bam-cd-title')
    if (!body || !foot || !title) return
    if (!cart.items || cart.items.length === 0) {
      title.textContent = 'Your bag'
      body.dataset.state = 'empty'
      body.innerHTML = renderEmpty()
      foot.setAttribute('hidden', '')
      updateShipTrack(cart)
      return
    }
    title.textContent = `Your bag · ${cart.item_count} item${cart.item_count === 1 ? '' : 's'}`
    body.dataset.state = 'filled'
    body.innerHTML = cart.items.map(renderLineItem).join('')
    $('#bam-cd-subtotal').textContent = fmtPrice(cart.items_subtotal_price)
    foot.removeAttribute('hidden')
    updateShipTrack(cart)
  }

  async function fetchCart() {
    const res = await fetch('/cart.js', { headers: { Accept: 'application/json' } })
    return res.json()
  }

  let inFlight = null
  async function refresh() {
    // Serialize refreshes so back-to-back qty clicks don't render stale state.
    inFlight = fetchCart().then((cart) => { render(cart); return cart })
    return inFlight
  }

  window.bamV3CartOpen = async function () {
    const d = drawer()
    if (!d) return
    d.setAttribute('data-open', '')
    d.setAttribute('aria-hidden', 'false')
    document.body.style.overflow = 'hidden'
    // Lazy-fetch on open so the drawer opens instantly and updates when the cart arrives.
    refresh()
  }

  window.bamV3CartClose = function () {
    const d = drawer()
    if (!d) return
    d.removeAttribute('data-open')
    d.setAttribute('aria-hidden', 'true')
    document.body.style.overflow = ''
  }

  window.bamV3CartChange = async function (key, quantity) {
    const q = Math.max(0, Number(quantity) || 0)
    try {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: q }),
      })
      await refresh()
    } catch (e) { console.error(e) }
  }

  // ── Wire up open triggers ──
  document.addEventListener('DOMContentLoaded', () => {
    // v2 header cart pill: open drawer instead of navigating to /cart.
    // Keep href pointing to /cart as a JS-off fallback.
    document.querySelectorAll('.bam-v2-nav__cart').forEach((a) => {
      a.addEventListener('click', (e) => { e.preventDefault(); bamV3CartOpen() })
    })
    // Close on Escape.
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && drawer()?.hasAttribute('data-open')) bamV3CartClose()
    })
    // Prime the header count once on load.
    fetchCart().then((cart) => updateHeaderCount(cart.item_count)).catch(() => {})
  })

  // Auto-open after a successful ATC. bam:cart:added is fired by bambody-v3-shop.js.
  document.addEventListener('bam:cart:added', () => {
    bamV3CartOpen()
  })
})();
